/* ============================================================
   LANCER-2 的骨架常數（設計文件 `.claude/notes/lancer2-design.md` §2）
   ============================================================

   CHASSIS-0 是「高、瘦、腿長 53%、逆關節（膝朝前）」的射擊型。
   LANCER-2 是它的**反比例**：矮、寬、腿短 47%、正關節（膝朝後）、
   前傾 15° 的格鬥架式。造型語彙（bevel/plate/seam/rib/joint/ram/cable）
   兩台完全共用 —— 差的是比例與姿態，不是技法。

   為什麼是比例而不是細節：戰場鏡頭下機體只有約 60px，能讀到的只有
   剪影與動作。兩台如果只差「胸口貼紙」，玩家換了機體不會有任何感覺。 */

/** LANCER-2 的站立基準姿態。動畫層會覆蓋大部分，這是所有偏移的原點。 */
export var LPOSE = {
  legL: { hip: 0.40, knee: -0.86 },   // 左＝支撐腿
  legR: { hip: 0.56, knee: -1.08 },   // 右＝前踏腿，折得更深
  hipYaw: 0.26,               // 髖線轉 15°（比 CHASSIS-0 的 11° 更開 → 格鬥架式）
  pelvisTilt: 0.10,
  torsoRoll: -0.07,
  torsoPitch: 0.26,           // 前傾 15°：近戰機體要「壓過去」
  headYaw: -0.16,
  headPitch: 0.10,            // 微低頭，視線壓在正前方
  armPitch: -0.10, armYaw: -0.22, armRoll: -0.26,   // 右臂持刃、肘略外張
  aimConverge: 0.10,
  /* 前臂近水平前舉 = 「刃已經架好」。垂下來的話刃會插進地板，
     而且 60px 下讀不出這台有武器（實拍證據：shots/lancer/ 第一輪）。 */
  forePitch: -1.32,
  pylonRoll: -0.16, pylonYaw: 0.14, // 左肩盾前傾護住身體中線
  stride: 0.24, strideK: 0.48       // 步幅短：腿短的機體用長步幅會變成劈腿
};

/** `bodyY` 是站立時髖在世界的高度（未套用 PROP.scale）。 */
export var LSTANCE = { bodyY: 1.56, ankle: 0.20, stance: 0.62 };

/** 骨架長度。`knee: -1` 取 IK 的**另一支解** —— 膝往後折的人型腿。
    l1 + l2 + foot = 1.74，站立髖高只有 1.56，所以膝永遠彎著 56°：
    這台機體站著的時候就是蹲踞待發的姿勢，不需要另外做「架式」動畫。 */
export var LIK = { l1: 0.80, l2: 0.74, foot: 0.20, knee: -1 };
